import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useCoapplicantStore from '../../../store/coapplicantStore/useCoapplicantStore';
import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import { locator } from '../../../testing/e2e-locator/locator';

const CoapplicantEmploymentSection = () => {
  const { t } = useTranslation();
  const {
    computed: { vehicleId },
  } = useDashboardStore();

  const {
    computed: {
      coapplicantCurrentIncomeAmount,
      coapplicantCurrentIncomeDuration,
      coapplicantCurrentIncomeStatus,
      coapplicantCurrentIncomeType,
    },
  } = useCoapplicantStore();

  return (
    <span data-testid={locator.components.coapplicantEmploymentSection.root}>
      <div className="head">
        <h3 data-testid={locator.components.coapplicantEmploymentSection.h3}>
          {t('CoapplicantReviewPage.employment')}
        </h3>
        <Link
          data-testid={locator.components.coapplicantEmploymentSection.editLink}
          to={`/applicant/${vehicleId}/coapp-edit-employment`}
        >
          {t('CoapplicantReviewPage.edit')}
        </Link>
      </div>

      <ul>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.status')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantEmploymentSection.status
              }
            >
              {coapplicantCurrentIncomeStatus}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.type')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantEmploymentSection.incomeType
              }
            >
              {coapplicantCurrentIncomeType}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.income')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantEmploymentSection.amount
              }
            >
              {coapplicantCurrentIncomeAmount}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.duration')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantEmploymentSection.duration
              }
            >
              {coapplicantCurrentIncomeDuration}
            </dd>
          </dl>
        </li>
      </ul>
    </span>
  );
};

export default CoapplicantEmploymentSection;
